import React from "react";
import { Link } from "react-router-dom";
import { GeographJireiButton } from "./geographJireiButton";

export const GeographTitle = ({ meta, meta2, params }) => {
  console.log(params.mode);

  return (
    <div className="m-1 mr-40 md:mr-48 pointer-events-auto">
      {params.mode == 8 ? (
        <div className="flex gap-2">
          <Link to={"/select?hikaku"} className="flex-1">
            <div className="h-10 md:h-12 p-1 md:p-3 flex bg-gradient-to-r from-slate-50 to-slate-100 rounded text-xs sm:text-sm md:text-xl font-extrabold">
              <div className="m-auto">{meta2["no"]}</div>
              <div className="m-auto">{meta2["title"]}</div>
              {/* <div className="m-auto">
                {meta["title_height_name"]}×{meta["title_color_name"]}
              </div> */}
              {/* <GeographJireiButton className="m-auto" meta={meta}>解説</GeographJireiButton> */}
            </div>
          </Link>

          <Link to={"/select"} className="flex-1">
            <div className="h-10 md:h-12 p-1 md:p-3 flex bg-gradient-to-r from-slate-50 to-slate-100 rounded text-xs sm:text-sm md:text-xl font-extrabold">
              <div className="m-auto">{meta["no"]}</div>
              <div className="m-auto">{meta["title"]}</div>
              {/* <div className="m-auto">
                {meta["title_height_name"]}×{meta["title_color_name"]}
              </div> */}
              {/* <GeographJireiButton className="m-auto" meta={meta}>解説</GeographJireiButton> */}
            </div>
          </Link>
        </div>
      ) : (
        <Link to={"/select"}>
          <div className="h-10 md:h-12 p-1 md:p-3 flex bg-gradient-to-r from-slate-50 to-slate-100 rounded text-xs sm:text-sm md:text-xl font-extrabold">
            <div className="m-auto">{meta["no"]}</div>
            <div className="m-auto">{meta["title"]}</div>
            <div className="m-auto">
              {meta["title_height_name"]}×{meta["title_color_name"]}
            </div>
            {/* <GeographJireiButton className="m-auto" meta={meta}>解説</GeographJireiButton> */}
          </div>
        </Link>
      )}
    </div>
  );
};
